module.exports = __webpack_public_path__ + "821d0d79f9fa00b84437abe143c716bf.png";